var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 48095539"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1157",
    cx: 26.9318,
    cy: 26.8168,
    r: 26.2901,
    fill: "#F7FFFB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Crown"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.6454 26.0029L36.2864 26.817L37.0772 26.1475L42.8628 21.2493C42.8754 21.308 42.8784 21.375 42.8677 21.4426L42.8677 21.4427L41.0282 33.123H13.9732L12.1337 21.4427L12.1337 21.4427C12.123 21.3751 12.126 21.3081 12.1386 21.2493L17.9243 26.1476L18.7151 26.8171L19.3561 26.003L27.5007 15.6599L35.6454 26.0029Z",
    stroke: "#00BCF8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.2924 36.1335V37.7027C13.2924 37.9441 13.2924 38.1398 13.2924 38.1398H41.7295C41.7295 38.1398 41.7295 37.9441 41.7295 37.7027V36.1335H13.2924Z",
    fill: "#00ADF8"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKing);
export default __webpack_public_path__ + "static/media/king.65472d3988069af281add7f2b73bb31d.svg";
export { ForwardRef as ReactComponent };